import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getCatalog, getCatalogTypesState } from "../../../redux/selectors";
import { Spinner, Table } from "react-bootstrap";
import Catalog from "./Catalog";
import styles from "./index.module.scss";
import { useFormik } from "formik";
import {
  addNewCatalog,
  addNewCatalogType,
  getAllCatalogTypes,
} from "../../../redux/reducers";
import AddCatalog from "../AddToCatalog";
import { useEffect, useState } from "react";
import api from "../../../api";
import { toast } from "react-toastify";

const AllCatalogs = () => {
  const dispatch = useAppDispatch();
  const formik = useFormik({
    initialValues: {
      catalogName: "",
    },
    onSubmit: ({ catalogName }) => {
      dispatch(addNewCatalogType(catalogName));
    },
  });
  const { allCatalogTypes, error, loader } = useAppSelector((state) =>
    getCatalogTypesState(state)
  );
  useEffect(() => {
    dispatch(getAllCatalogTypes());
  }, []);

  return (
    <div className={styles.root + " container"}>
      <div className={styles.sidebar}>
        <h3>Создать новый каталог</h3>
        <form onSubmit={formik.handleSubmit}>
          <input
            onChange={formik.handleChange}
            type="text"
            placeholder="Имя каталога"
            name="catalogName"
            id="catalogName"
          />
          <button type="submit">Создать</button>
        </form>
      </div>
      <div className={styles.catalogs}>
        <h1 className="title">Каталоги</h1>
        <Table>
          <thead>
            <tr>
              <th>Имя каталога</th>
              <th style={{ textAlign: "center" }}>Действие</th>
            </tr>
          </thead>
          {loader ? (
            <tbody>
              <tr>
                <th>Загрузка...</th>
              </tr>
            </tbody>
          ) : error ? (
            <tbody>
              <tr>
                <th>
                  Ошибка
                  <span style={{ display: "none" }}>
                    {toast("Ошибка! Перезагрузите Страницу", { type: "error" })}
                  </span>
                </th>
              </tr>
            </tbody>
          ) : allCatalogTypes.length != 0 ? (
            <tbody>
              {allCatalogTypes.map((e, i) => (
                <Catalog
                  catalogTypeId={e.catalogTypeId}
                  index={i + 1}
                  catalogName={e.catalogName}
                  key={e.catalogTypeId}
                />
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <th>Пусто</th>
              </tr>
            </tbody>
          )}
        </Table>
      </div>
    </div>
  );
};

export default AllCatalogs;
